import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/solutions/[slug]/components/ActionButtonSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/solutions/[slug]/components/HeroSectionNewActionButton.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/solutions/[slug]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Disclosure"] */ "/work/repo/redesign/components/Disclosure.jsx");
